import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {Exception} from '../exception';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'rtapp-error-dialog',
    templateUrl: './error-dialog.component.html',
    styles: [],
    imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class ErrorDialogComponent implements OnInit {

    type = 'unexpected';
    messages = {
        unexpected: 'Sorry that an unexpected error is occurred and cannot be resumed.\n' +
            '        Please try reload the page (press F5). If the error is still exists,\n' +
            '        please send following error message to SRO for\n' +
            '        assistants.',
        fatal: `Operation cannot be further processed due to below error.`,
        error: ``,
        business: '',
    };

    constructor(@Inject(MAT_DIALOG_DATA) public data: Exception | Error | any) {
        if (!!data.type) {
            this.type = data.type;
        } else if (data instanceof Exception) {
            this.type = data.type;
        }
    }

    ngOnInit() {
    }

}
